import { render, staticRenderFns } from "./OrderPDFDetail.vue?vue&type=template&id=aedc4d76"
import script from "./OrderPDFDetail.vue?vue&type=script&lang=js"
export * from "./OrderPDFDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports